// https://vuex.vuejs.org/en/actions.html
import Vue from 'vue'

export default {
  login ({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')

      Vue.prototype.Maglink.Login(user)
        .then(resp => {
          const token = resp.data.token
          Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
          resolve(resp)
        })
        .catch(err => {
          localStorage.removeItem('user')
          commit('auth_error')
          reject(err)
        })
    })
  },

  user_details ({ commit }, token) {
    return new Promise((resolve, reject) => {
      Vue.prototype.Maglink.CurrentUser()
        .then(resp => {
          const user = resp.data
          user.token = token
          localStorage.setItem('user', JSON.stringify(user))

          Vue.prototype.Maglink.SetLoggedUser(user)

          commit('auth_success', user)
          resolve(resp)
        })
        .catch(err => {
          localStorage.removeItem('user')
          commit('auth_error')
          reject(err)
        })
    })
  },

  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('user')
      delete Vue.prototype.$http.defaults.headers.common['Authorization']
      commit('logout')
      resolve()
    })
  },

  showSnackbar ({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit('snackbar', params)
      resolve()
    })
  }
}
